var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowUndo)?_c('div',{staticClass:"undo-btn",style:({ top: _vm.top, left: _vm.left }),on:{"click":_vm.undoAct}},[_c('i',{staticClass:"fas fa-undo",attrs:{"title":"Hoàn tác"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }